
import React from 'react'
import { BrandStack as StackComponent } from './stacks'

import { GenericItem } from './generic'

export const BrandItem = props => {
  return <GenericItem {...props} StackComponent={StackComponent} />
}

export const StrippedBrandItem = props => <BrandItem {...props} />